import { isAsyncIterable, isIterable } from "./_internal/utils.js";
async function async(iterable) {
    const res = [];
    for await (const item of iterable) {
        res.push(item);
    }
    return res;
}
function toArray(iter) {
    if (isAsyncIterable(iter)) {
        return async(iter);
    }
    else if (isIterable(iter)) {
        return Array.from(iter);
    }
    else {
        return [];
    }
}
export default toArray;
//# sourceMappingURL=toArray.js.map